module.exports = __webpack_public_path__ + "img/system19-mini.1651307c.png";